import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { InvisibleReCaptchaComponent } from 'ngx-captcha';

import { LzUserServiceV2 } from "../../../lz-user/services/lz-user.serivce.v2";
import { LzLanguageService } from '../../../../services/lz-language/lz-language.service';
import { CustomRequestService } from '../../../../services/custom-request/custom-request.service';
import { LzProductConfig } from '../../../../services/product-config/poduct-config';

declare var $: any;
declare var grecaptcha: any;

@Component({
  selector: 'lz-feedback-component',
  template: `<div>
  <div id="feedback">
    <div class="modal-header">
      <label id="header-form" for="feedback-text">
        <i class="fa fa-envelope-o"></i>
        {{'lz-feedback.title' | translate}}
        <svg data-test="feedback-close-icon" id="header-close" (click)="cancel()" class="close" style="width:24px;height:24px"
          viewBox="0 0 24 24">
          <path fill="#000000" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
        </svg>
      </label>
    </div>
    <div class="bookmark-modal modal-body">
      <div class="feedback-input-group" *ngIf="!sendSuccess && !isPending">
        <span class="group-title">{{'lz-feedback.message' | translate}}</span>
        <textarea data-test="feedback-message-input" class="group-input lz-feedback-textarea" [ngClass]="{'group-input-error': message.invalid && isMessageError}"
          (focusout)="checkInput(message, 'Message')" maxlength="3072" type="text" placeholder="{{'lz-feedback.placeholder' | translate}}"
          [formControl]="message" required></textarea>
        <div class="group-error" [hidden]="!(message.invalid && isMessageError)">
          {{'lz-feedback.' + getErrorMessage('message', message) | translate}}
        </div>
      </div>
      <div class="feedback-input-group" id="addScreenshot" *ngIf="!sendSuccess && !isPending">
        <div class="file_upload_image">
          <span class="group-title">{{'lz-feedback.screenshot' | translate}}</span>
          <span data-test="feedback-button-choose-file" class="group-button btn-primary" (click)="clickUpload()">{{'lz-feedback.upload_button'
            | translate}}</span>
          <mark name="fieldName1" ngDefaultControl class="imageFile" [(ngModel)]="fileName" [hidden]="true"></mark>
          <input data-test="feedback-fake-file-input" name="fieldName2" ngDefaultControl class="group-input file-input"
            type="text" (click)="clickUpload()" [(ngModel)]="fileName" />
          <input data-test="feedback-file-input" name="fieldName3" ngDefaultControl name="file" class="group-input group-file-input"
            [hidden]="true" (change)="checkFile()" type="file" [(ngModel)]="form.img" />
          <div class="group-error" [hidden]="!(fileSizeError)">
            {{'lz-feedback.fileSizeError' | translate}}
          </div>
          <div class="group-error" [hidden]="!(fileTypeError)">
            {{'lz-feedback.fileTypeError' | translate}}
          </div>
        </div>
      </div>
      <div class="feedback-input-group" *ngIf="!sendSuccess && !isPending">
        <span class="group-title">{{'lz-feedback.phone' | translate}}</span>
        <input data-test="feedback-phone-input" class="group-input" [ngClass]="{'group-input-error': phone.invalid && isPhoneError}"
          (focusout)="checkInput(phone, 'Phone')" type="text" placeholder="+380XXXXXXXXX" value="+380" pattern="^\\+?[0-9]{7,16}$"
          [formControl]="phone" />
        <div class="group-error" [hidden]="!(phone.invalid && isPhoneError)">
          {{'lz-feedback.' + getErrorMessage('phone', phone) | translate}}
        </div>
      </div>
      <div class="feedback-input-group" *ngIf="!sendSuccess && !isPending">
        <span class="group-title">{{'lz-feedback.authMail' | translate}}</span>
        <input data-test="feedback-email-input" class="group-input" [ngClass]="{'group-input-error': email.invalid && isEmailError}"
          (focusout)="checkInput(email, 'Email')" type="text" placeholder="{{'lz-feedback.emailRequired' | translate}}"
          pattern="^[a-z0-9._-]+@[a-z0-9._-]+\\.[a-z]{2,}$" [formControl]="email" required />
        <div class="group-error" [hidden]="!(email.invalid && isEmailError)">
          {{'lz-feedback.' + getErrorMessage('email', email) | translate}}
        </div>
      </div>
      <div id="sendResult" *ngIf="!sendSuccess && isPending">
        <span> {{'lz-feedback.submitProcessMsg' | translate}}</span><img src='/dist/ng2/src/assets/pl-header-assets/img/spinner.gif' />
      </div>
      <div class="feedback-thx-message" *ngIf="sendSuccess && !isPending">
        {{'lz-feedback.thx' | translate}}
      </div>
      <button data-test="feedback-reopen-button" class="btn btn-primary" *ngIf="sendSuccess && !isPending" (click)="reOpen()">
        {{'lz-feedback.reSubmit' | translate}}
      </button>
    </div>
    <div class="modal-footer" *ngIf="!sendSuccess && !isPending">
      <div class="ui-text-align-right" style="text-align: right">
        <button data-test="feedback-submit-button" ng-disabled="fileSizeError || fileTypeError" class="feedback-footer-btn"
          (click)="captchaRef.execute()" [lzLog]="'header/click/btnSendFeedback'">
          {{'lz-feedback.submit' | translate}}
        </button>
        <div data-test="feedback-close-button" class="feedback-footer-btn-cancel" (click)="cancel()">{{'lz-feedback.cancel'
          | translate}}</div>
      </div>
      <div class="feedback-message-div">
        <div class="feedback-message"></div>
      </div>
      <input data-message type="hidden" name="label" value="message" />
    </div>
  </div>
  <form [formGroup]="cFormGroup">
    <ngx-invisible-recaptcha #captchaRef hl="uk" siteKey="6LcfMkgUAAAAAOmzWe6krfV-cgR3MczaQVrqxUVR" (success)="showResult($event)"
      formControlName="recaptcha">
    </ngx-invisible-recaptcha>
  </form>
</div>
`,
  styles: [`.lz-pl-container{position:relative;display:block;margin-left:auto;margin-right:auto;padding:0 12px}@media (min-width:758px){.lz-pl-container{width:732px;padding:0}}@media (min-width:1002px){.lz-pl-container{width:976px}}@media (min-width:1490px){.lz-pl-container{width:1440px}}.lz-pl-container-new{position:relative;display:block;margin-left:auto;margin-right:auto;padding:0 12px}@media (min-width:758px){.lz-pl-container-new{width:732px;padding:0}}@media (min-width:1200px){.lz-pl-container-new{width:1200px}}@media (min-width:1490px){.lz-pl-container-new{width:1440px}}.modal-lg{width:900px}*,:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box}*{text-shadow:none!important}body,h1,h2,h3,h4,h5,h6,ol,p,ul{margin:0;padding:0;font-weight:400}ol,ul{list-style:none}img{max-width:100%;height:auto;vertical-align:middle}.h1,.h2,.h3,.h4,.h5,.h6,button,h1,h2,h3,h4,h5,h6,input,p,textarea{font-family:inherit;font-size:inherit;font-weight:inherit}input:focus,textarea:focus{outline:0}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{line-height:1.1}fieldset{border:none}::ng-deep .cdk-overlay-container{z-index:1111}::ng-deep .cdk-overlay-container ::ng-deep .cdk-overlay-pane{max-width:95vw!important}::ng-deep .cdk-overlay-container ::ng-deep .cdk-overlay-pane ::ng-deep .mat-dialog-container{margin:0;padding:0;max-height:95vh;border-radius:0}@media (max-width:757px){::ng-deep .cdk-overlay-container ::ng-deep .cdk-overlay-pane ::ng-deep .mat-dialog-container{max-height:80vh}}::ng-deep .cdk-global-scrollblock{position:static!important;overflow:hidden}::ng-deep .cdk-global-scrollblock body{overflow:hidden}#feedback{font-family:Geometria,Arial,sans-serif;width:auto;padding:10px}@media (min-width:758px){#feedback{width:706px}}#feedback #feedbackResult{border:none;width:100%}#feedback label{font-weight:500}#feedback .modal-header{padding:15px}#feedback .modal-body .feedback-input-group{position:relative;display:block;width:100%;height:auto;margin-bottom:20px}#feedback .modal-body .feedback-input-group .group-title{font:500 18px "Open Sans",sans-serif;color:#464646;margin-bottom:10px;display:inline-block}#feedback .modal-body .feedback-input-group .group-input-error{border:1px solid red!important}#feedback .modal-body .feedback-input-group .group-error{text-align:left;color:#ff2f2e;margin-top:3px}#feedback .modal-body .feedback-input-group .group-button{overflow:hidden;text-overflow:ellipsis;-webkit-box-sizing:border-box;box-sizing:border-box;-moz-box-sizing:border-box;width:auto;height:44px;display:block;position:absolute;right:0;z-index:1;line-height:44px;padding:0 20px;cursor:pointer;background-image:none;color:#fff;background-color:#00adfa}#feedback .modal-body .feedback-input-group .group-button:after{position:absolute;content:'';right:0;left:0;bottom:0;height:4px;background:#009ce9;transition:.15s;-webkit-transition:.15s;-o-transition:.15s;z-index:-1}#feedback .modal-body .feedback-input-group .group-input{position:relative;display:block;width:100%;height:44px;resize:none;font-size:16px;line-height:normal;color:#474e62;padding:10px 24px;background-color:#fafafa;border:1px solid #e0e3e4;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075);-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out}#feedback .modal-body .feedback-input-group .group-input:focus{outline:0}#feedback .modal-body .feedback-input-group .group-file-input{visibility:hidden;margin-top:-44px}#feedback .modal-body .feedback-input-group .file-input{cursor:pointer}#feedback .modal-body .feedback-input-group .lz-feedback-textarea{height:200px}#feedback .modal-body .feedback-thx-message{margin-bottom:15px;font-style:italic}#feedback .modal-footer .feedback-footer-btn{background-image:none;display:inline-block;margin-bottom:0;font-weight:400;text-align:center;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;white-space:nowrap;padding:15px 24px;font-size:16px;line-height:1.42857143;border-radius:4px;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;color:#fff;background-color:#00adfa;border:none;overflow:hidden;z-index:1;position:relative;-webkit-box-shadow:0 2px 5px 0 rgba(0,0,0,.15);box-shadow:0 2px 5px 0 rgba(0,0,0,.15);margin-right:10px;width:140px!important}#feedback .modal-footer .feedback-footer-btn:after{position:absolute;content:'';right:0;left:0;bottom:0;height:4px;background:#009ce9;transition:.15s;-webkit-transition:.15s;-o-transition:.15s;z-index:-1}@media (max-width:479px){#feedback .modal-footer .feedback-footer-btn{margin-top:5px;margin-right:0}}#feedback .modal-footer .feedback-footer-btn-cancel{background-image:none;display:inline-block;margin-bottom:0;text-align:center;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;white-space:nowrap;padding:15px 24px;font-size:16px;line-height:1.42857143;border-radius:4px;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;color:#666f7a;background-color:#fff;z-index:1;overflow:hidden;position:relative;font-weight:300;-webkit-box-shadow:none;box-shadow:none;border:1px solid #e0e3e4!important}#feedback #header-form{font:500 18px "Open Sans",sans-serif!important;width:100%}#feedback #header-form i{position:relative;top:3px;font-size:32px}#feedback #header-form #header-close{position:relative;cursor:pointer;float:right;top:10px}`]
})

export class LzFeedbackComponent {
  @ViewChild(InvisibleReCaptchaComponent) captcha: InvisibleReCaptchaComponent;

  public resolved(captchaResponse: string) {}

  public productConfig: any;

  public message: FormControl = new FormControl('', [Validators.required]);
  public isMessageError: boolean = false;

  public phone: FormControl = new FormControl('');
  public isPhoneError: boolean = false;

  public email: FormControl = new FormControl('', [Validators.required]);
  public isEmailError: boolean = false;

  public isSubmitted = false;

  public cFormGroup: FormGroup;
  public lang: string;
  public userInfo: any = {};
  public imgURL: any = '';
  public isPending: boolean = false;
  public sendSuccess: boolean = false;
  public fileTypeError: boolean = false;
  public fileSizeError: boolean = false;
  public fileName: string = '';
  public form: any = {
    text: '',
    phone: '',
    screenshot: '',
    f_ext: '',
    email: ''
  };

  //noinspection JSAnnotator
  constructor(public dialogRef: MatDialogRef < LzFeedbackComponent > ,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private language: LzLanguageService,
    private user: LzUserServiceV2,
    private request: CustomRequestService,
    private config: LzProductConfig) {
    this.lang = this.language.identifyLanguage();

    this.productConfig = this.config.getProductSettings();

    this.user.getUserInfo(function (info) {
      this.userInfo = info;
      if (this.userInfo.phone) {
        this.phone.setValue(this.userInfo.phone);
      }
      if (this.userInfo.ligaId) {
        this.email.setValue(this.userInfo.ligaId);
      }
    }.bind(this));
    this.cFormGroup = new FormGroup({
      'recaptcha': new FormControl(null, [Validators.required])
    });
  }

  checkInput(form: FormControl, type: string): void {
    if (type === 'Email') {
      this.email.setValue(this.email.value.toLowerCase());
    }
    if (form.valid) {
      this['is' + type + 'Error'] = false;
    } else {
      this['is' + type + 'Error'] = true;
    }
  }

  checkErrors(): boolean {
    if (this.message.status === 'VALID' && this.email.status === 'VALID' && this.phone.status === 'VALID' && !this.fileTypeError && !this.fileSizeError) {
      return true;
    } else {
      if (this.message.status !== 'VALID') {
        this.isMessageError = true;
      }
      if (this.email.status !== 'VALID') {
        this.isEmailError = true;
      }
      if (this.phone.status !== 'VALID') {
        this.isPhoneError = true;
      }
    }
    return false;
  }

  getErrorMessage(type: string, form: FormControl): string {
    let msg: string = '';
    switch (type) {
      case 'message':
        msg = form.hasError('required') ? 'submitError' : '';
        break;
      case 'phone':
        msg = form.hasError('pattern') ? 'phonePattern' : '';
        break;
      case 'email':
        msg = form.hasError('required') ? 'emailRequired' : form.hasError('pattern') ? 'emailPattern' : '';
        break;
      default:
        break;
    }
    return msg;
  }

  clickUpload(): void {
    $('#addScreenshot [type="file"]').click();
  }

  submit = function (): void {

  }

  checkFile(): void {
    $('#addScreenshot [type="file"]').removeAttr('title');
    var wrapper = $('.file_upload_image'),
      inp = ( < HTMLInputElement > < any > wrapper.find("input")),
      btn = wrapper.find(".button"),
      lbl = wrapper.find('.imageFile');

    var file = ( < any > document).querySelector('input[type=file]').files[0];
    var reader = < any > new FileReader();

    reader.onloadend = () => {
      this.imgURL = reader.result.slice(reader.result.indexOf(',') + 1);
    };

    function getExtension(filename) {
      var parts = filename.split('.');
      return parts[parts.length - 1];
    }

    var fType = getExtension(file.name);
    if (fType.toLowerCase() != 'jpg' && fType.toLowerCase() != 'gif' && fType.toLowerCase() != 'bmp' && fType.toLowerCase() != 'png' && fType.toLowerCase() != 'jpeg') {
      this.fileTypeError = true;
    } else {
      this.fileTypeError = false;
    }

    if (file && file.size < 5000 * 1024) {
      reader.readAsDataURL(file);
      this.fileSizeError = false;
    } else if (file && file.size > 5000 * 1024) {
      this.fileSizeError = true;
    }

    var file_api = (( < any > window).File && ( < any > window).FileReader && ( < any > window).FileList && window.Blob) ? true : false;

    var file_name;
    if (file_api && inp[1].files[0]) {
      file_name = inp[1].files[0].name;
      this.form.f_ext = file_name.slice(-3);
    } else
      file_name = inp.value.replace("C:\\fakepath\\", '');

    if (!file_name.length)
      return;

    if (file_name) {
      lbl.text(file_name);
      this.fileName = file_name;
      btn.text("ÐÑÐ±ÑÐ°ÑÑ");
    } else
      btn.text(file_name);
    this.fileName = file_name;
  };

  sendData = (data: any, callback ? : any): void => {
    this.request.postRequestWithFormData(
      this.config.getApiLink() + '/lz-platforma/feedback/v1.0/add',
      data,
      undefined, {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    ).subscribe((msg) => {
      if (callback) callback(msg);
      $('#sendResult').empty().append(msg);
      this.sendSuccess = true;
      this.isPending = false;
    });
  };

  showResult = (captchaResponse: string): any => {
    this.form.screenshot = encodeURIComponent(this.imgURL);
    this.checkErrors();
    if (this.checkErrors()) {
      let formData = {
        'text': this.message.value || '',
        'phone': this.phone.value || '',
        'screenshot': this.form.screenshot || '',
        'f_ext': this.form.f_ext || '',
        'email': this.email.value || '',
        'g-recaptcha-response': captchaResponse || ''
      }
      this.isPending = true;
      this.sendData(formData);
    } else {
      this.captcha.resetCaptcha();
      try {
        grecaptcha.reset();
      } catch(e) { }
    }
  };

  reOpen = (): void => {
    this.message = new FormControl('', [Validators.required]);
    this.isMessageError = false;
    this.phone = new FormControl('');
    this.isPhoneError = false;
    if (this.userInfo.phone) {
      this.phone.setValue(this.userInfo.phone);
    }
    this.email = new FormControl('', [Validators.required]);
    this.isEmailError = false;
    if (this.userInfo.ligaId) {
      this.email.setValue(this.userInfo.ligaId);
    }
    this.imgURL = '';
    this.sendSuccess = false;
    this.fileTypeError = false;
    this.fileSizeError = false;
    this.fileName = '';
    this.form = {
      text: '',
      phone: '',
      screenshot: '',
      f_ext: '',
      email: ''
    };
    this.captcha.resetCaptcha();
    try {
      grecaptcha.reset();
    } catch(e) { }
    this.isSubmitted = false;
    this.isPending = false;
  }

  cancel(): void {
    this.dialogRef.close();
  }

}
